import React, { FC } from 'react';
import styled, { StyledComponent } from '@emotion/styled';
import { FormLabel } from './field-label';
import { InputStyle, InputStyleProps, InputHintStyle } from './input-style';
import { ErrorInputIcon } from '../../icons/ErrorInputIcon';
import { ValidInputIcon } from '../../icons/ValidInputIcon';
import { FieldValidationMessage } from './field-validation-message';

/**
 * currently `.withComponent` is type-unsafe
 * Issue can be seen here https://github.com/emotion-js/emotion/issues/2012
 */
export const TextArea = styled(InputStyle)`
  line-height: 1.25;
`.withComponent('textarea') as StyledComponent<
  React.HTMLProps<HTMLTextAreaElement>,
  InputStyleProps,
  {}
>;

const TextAreaWrapper = styled.div`
  position: relative;
  line-height: 1;
  & > svg {
    position: absolute;
    width: 18px;
    right: 10px;
    top: 16px;
  }
`;
export type TextAreaFieldProps = React.HTMLProps<HTMLTextAreaElement> &
  InputStyleProps & {
    label: string;
    hint?: string;
    validationMessage?: string;
    ref?: React.RefObject<HTMLInputElement>;
  };

export const TextAreaField: FC<TextAreaFieldProps> = props => {
  const disabled = props.status === 'readonly' || props.disabled;
  const isValidationMessageVisible = (str?: string): str is string =>
    str !== undefined && props.status === 'invalid';
  return (
    <TextAreaWrapper>
      <FormLabel id={props.label.split(' ').join('')} htmlFor={props.id}>
        {props.label}
      </FormLabel>
      {props.hint && <InputHintStyle>{props.hint}</InputHintStyle>}
      <TextAreaWrapper>
        <TextArea {...props} disabled={disabled} />
        {props.status === 'invalid' && <ErrorInputIcon />}
        {props.status === 'valid' && <ValidInputIcon />}
        {isValidationMessageVisible(props.validationMessage) && (
          <FieldValidationMessage message={props.validationMessage} />
        )}
      </TextAreaWrapper>
    </TextAreaWrapper>
  );
};
